import useArchiveInstrumentConfiguration from '@hooks/mutations/registry/configuration/useArchiveInstrumentConfiguration';
import useMutate from '@hooks/mutations/useMutate';
import useRegistrarService from '@hooks/queries/registry/onboarding/useRegistrarService';
import React from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { InstrumentConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/Instrument';
import { ChoiceDialogProps } from '../../../components/ChoiceDialog';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { ERR_ARC_INST_CONF, SUC_ARC_INST_CONF } from '../../../utils/strings';
import { ModifyInstrumentConfigurationDialog } from './ModifyInstrumentConfigurationDialog';
import { ModifyProvierAppRewardBeneficiariesDialog } from './ModifyProviderAppRewardBeneficiariesDialog';

export const useCreateInstrumentConfigurationActions = (
  onClose: () => void,
  r?: TemplateContract<InstrumentConfiguration>,
) => {
  const registrarService = useRegistrarService();
  const { party } = useParties();
  const mutate = useMutate();
  const archiveInstrumentConfiguration = useArchiveInstrumentConfiguration();

  const { showBoundary } = useErrorBoundary<Error>();

  const actions: ChoiceDialogProps['actions'] = [];

  const archive = React.useCallback(
    (row?: TemplateContract<InstrumentConfiguration>) => {
      if (!row) {
        throw Error('no row selected');
      }
      if (!registrarService.data) {
        showBoundary(
          new Error(ERR_ARC_INST_CONF, { cause: 'Registrar service is not available.' }),
        );
        return Promise.resolve();
      }
      const payload = {
        registrarServiceCid: registrarService.data.contractId,
        instrumentConfigurationCid: row.contractId,
      };
      return mutate(archiveInstrumentConfiguration, payload, SUC_ARC_INST_CONF, ERR_ARC_INST_CONF);
    },
    [registrarService, archiveInstrumentConfiguration, mutate, showBoundary],
  );
  if (!r) {
    return actions;
  }
  if (r.payload.provider === party) {
    actions.push({
      name: 'App Reward Beneficiaries',
      form: (
        <ModifyProvierAppRewardBeneficiariesDialog
          open
          disableDialog
          intrumentConfiguration={r}
          onClose={onClose}
        />
      ),
    });
  }
  if (r.payload.registrar === party)
    actions.push(
      {
        name: 'Modify',

        form: (
          <ModifyInstrumentConfigurationDialog
            disableDialog
            open
            onClose={onClose}
            instrumentConfiguration={r}
          />
        ),
      },
      {
        name: 'Archive',

        action: async () => {
          await archive(r);
          onClose();
        },
        color: 'error',
      },
    );
  return actions;
};
